import useSWR from 'swr';
import { API_HOST } from '../helpers/constants';
import { fetcher } from '../utils';

export function useBlogAuthor(id) {
  const url = `${API_HOST}/blog-authors/${id}`;

  const { data: responseData, error, isLoading, mutate } = useSWR(id ? url : null, fetcher);

  const revalidate = () => mutate(url);

  return {
    blogAuthor: responseData,
    isLoading,
    isError: error,
    revalidate
  };
}
